import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {ChartData, ChartType} from "chart.js";

@Component({
    selector: 'ds-chart',
    templateUrl: './ds-chart.component.html',
    styleUrls: ['./ds-chart.component.scss'],
    standalone: false
})
export class DsChartComponent implements OnInit, OnChanges {
  @Input() inputData: number[];
  @Input() chartColor: string[];

  public doughnutChartData: ChartData<'doughnut'> = {
    labels: null,
    datasets: [{
      data: [],
      backgroundColor: ["#2160b5", "#f4f4f4"],
      weight: 50
    }]
  };

  public doughnutChartType: ChartType = 'doughnut';
  public doughnutChartOptions: any = {
    hover: {
      mode: null
    },
    plugins: {
      tooltip: {
        enabled: false
      }
    }
  };

  ngOnInit() {
    this.updateChartData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inputData'] || changes['chartColor']) {
      // Force a new object creation to trigger change detection
      this.doughnutChartData = {
        ...this.doughnutChartData,
        datasets: [{
          ...this.doughnutChartData.datasets[0],
          data: this.inputData ? [...this.inputData] : [],
          backgroundColor: this.chartColor ? [...this.chartColor] : ["#2160b5", "#f4f4f4"]
        }]
      };
    }
  }

  private updateChartData() {
    if (this.doughnutChartData.datasets.length > 0) {
      this.doughnutChartData = {
        ...this.doughnutChartData,
        datasets: [{
          ...this.doughnutChartData.datasets[0],
          data: this.inputData ? [...this.inputData] : [],
          backgroundColor: this.chartColor ? [...this.chartColor] : ["#2160b5", "#f4f4f4"]
        }]
      };
    }
  }
}
